import styled from '@emotion/styled';
import { useGlobal } from '../../hooks';
import { When } from 'react-if';
import {
    getPageUrl,
    GoogleAggregateChip,
    SourceIcon,
    useAnalyticsClickEvent,
} from 'rwl-ui';
import { ClickTargets } from 'rwl-shared/dist/models/analytics';

const GoogleAggregateContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: var(--rwl-spacing-md);
    border: 1px solid var(--rwl-color-neutral-border);
    border-radius: var(--rwl-radius-lg);
    padding: var(--rwl-spacing-sm);
    &:hover {
        background-color: var(--rwl-palette-gray-100);
    }
`;

export const GoogleAggregate = () => {
    const { config } = useGlobal();
    const sendClickEvent = useAnalyticsClickEvent();

    if (!config) {
        return null;
    }
    const { gmbIntegration } = config;
    return (
        <When condition={gmbIntegration && gmbIntegration.reviewCount}>
            <GoogleAggregateContainer>
                <GoogleAggregateChip
                    source="GMB"
                    count={gmbIntegration?.reviewCount || 0}
                    rating={gmbIntegration?.reviewRating || 0}
                    onClick={() => {
                        sendClickEvent({
                            url: getPageUrl(),
                            target: ClickTargets.EXTERNAL_REVIEWS,
                        });
                        window.open(gmbIntegration.url, '_blank');
                    }}
                />
            </GoogleAggregateContainer>
        </When>
    );
};

const LinkContainer = styled.div`
    padding: var(--rwl-spacing-sm) 0;
    a {
        color: grey;
        padding-left: var(--rwl-spacing-sm);
    }

    display: flex;
    align-items: center;
`;

export const MiniGoogleAggregate = () => {
    const { config } = useGlobal();
    const sendClickEvent = useAnalyticsClickEvent();

    if (!config) {
        return null;
    }
    const { gmbIntegration } = config;

    return (
        <When condition={gmbIntegration && gmbIntegration.reviewCount}>
            <LinkContainer>
                <SourceIcon source="GMB" />
                <a
                    href={gmbIntegration.url}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() =>
                        sendClickEvent({
                            url: getPageUrl(),
                            target: ClickTargets.EXTERNAL_REVIEWS,
                        })
                    }
                >
                    {(gmbIntegration?.reviewRating || 0).toFixed(1)}{' '}
                    {`(${gmbIntegration.reviewCount} reviews)`}
                </a>
            </LinkContainer>
        </When>
    );
};
